export default "__VITE_ASSET__CGI1cekO__"